import React from 'react';
import { FormValues } from '@wix/form-viewer';

export type FormComponentContextType = {
  wixFormValues: FormValues;
  participantFormValues: FormValues[];
  bookerFormValues?: FormValues;
  isCartConflictError?: boolean;
  isUpsellPluginInstalled?: boolean;
  /** Whether the site's Pricing Plans are migrated to eCom — see isPlanAndBookEnabled. */
  isPricingPlansMigratedToEcom?: boolean;
  dateRegionalSettingsLocale: string;
};

const FormComponentContext = React.createContext<FormComponentContextType>(
  {} as FormComponentContextType,
);
export const FormComponentContextProvider = FormComponentContext.Provider;

export const useFormComponentContext = () =>
  React.useContext(FormComponentContext);
